<template>
  <div
    class="
      col-span-full
      grid grid-cols-1
      gap-4
      md:grid-cols-2
      lg:grid-cols-3
      pb-4
      mt-8
    "
  >
    <Content
      class="col-span-full"
      :title="$route.name"
      v-loading="wrapperLoading"
      :router="{
        name: 'HISTORY_ROUTES',
      }"
    >
      <RoutingMap :tripDetail="tripDetails" />
    </Content>

    <Content
      class="col-span-full"
      title="SPEED_GRAPH"
      :showBreadcrumb="false"
      :showAdd="false"
      v-if="tripDetails != null"
    >
      <VueApexCharts
        type="line"
        height="350"
        :options="{
          chartOptions,
          labels: date,
          annotations: {
            yaxis: [
              {
                y: tripDetails.max_speed,
                borderColor: '#b30000',

                label: {
                  borderColor: '#b30000',
                  textAnchor: 'start',
                  style: {
                    color: '#fff',
                    background: '#b30000',
                  },
                  text: `${$t('MAX_SPEED')}: ${tripDetails.max_speed}km/h`,
                },
              },
              {
                y: tripDetails.avg_speed,
                borderColor: '#d0aa00',
                label: {
                  borderColor: '#d0aa00',
                  textAnchor: 'start',
                  style: {
                    color: '#fff',
                    background: '#d0aa00',
                  },
                  text: `${$t('AVG_SPEED')}: ${tripDetails.avg_speed}km/h`,
                },
              },
            ],
          },
          points: [
            {
              x: new Date('01 Dec 2017').getTime(),
              y: tripDetails.max_speed,
              marker: {
                size: 8,
                fillColor: '#fff',
                strokeColor: 'red',
                radius: 2,
                cssClass: 'apexcharts-custom-class',
              },
              label: {
                borderColor: '#FF4560',
                offsetY: 0,
                style: {
                  color: '#fff',
                  background: '#FF4560',
                },

                text: 'Point Annotation',
              },
            },
          ],
        }"
        :series="speeds"
      ></VueApexCharts>
    </Content>
  </div>
</template>
<script>
import RoutingMap from '@/components/reports/history/RoutingMap.vue'
import { tripDetail } from '@/api/reports'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    RoutingMap,
    VueApexCharts,
  },
  data() {
    return {
      path: null,
      wrapperLoading: true,
      speeds: [
        {
          data: [],
        },
      ],
      anomalyPoints: null,
      date: [],
      tripDetails: null,
      series: [
        {
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          locales: ['fa'],
          defaultLocale: 'fa',
          type: 'line',
          id: 'areachart-2',
          fontFamily: 'Vazir',
        },
        annotations: {
          yaxis: [],
          xaxis: [],
          points: [],
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        grid: {
          padding: {
            right: 0,
            left: 0,
          },
        },
        title: {
          text: 'Line with Annotations',
          align: 'right',
        },

        xaxis: {
          type: 'datetime',
        },
      },
    }
  },
  mounted() {
    tripDetail.api(this.$route.params.id).then((res) => {
      this.wrapperLoading = false
      this.speeds[0].data = res.speeds.map((i) => i + 'km/h')
      this.tripDetails = res
      this.date = res['datetimes'].map((i) => {
        return (
          new Date(i).toLocaleDateString('fa-IR') +
          ' | ' +
          new Date(i).toLocaleTimeString('fa-IR')
        )
      })
      // routinAnomaly.api(this.$route.params.id).then((res) => {
      //   this.anomalyPoints = res;
      // });
    })
  },
}
</script>
